//@flow
import styled from "styled-components"

export const Title = styled.h1`
  font-family: "din-condensed";
  font-size: 50px;
  font-weight: 400;
  color: #fff;
  text-transform: uppercase;
  margin: 0;
  display: inline-block;
  margin: auto 0;
`

export const Subtitle = Title.withComponent("h2").extend`
  color: #c9eaff;
  font-weight: 300;
  margin-left: 1rem;
`

export const Block = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 1rem 2rem 1rem;
`

export const InfoCol = styled.div`
  width: 88px;
  flex-basis: 88px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
`

export const ContentCol = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-right: 1rem;
`

export const ContentText = styled.p`
  font-family: "din-condensed";
  font-size: 36px;
  font-weight: 300;
  color: #fff;
  margin: 1rem 0;
`

export const CurrentStatus = ContentText.withComponent("h3").extend`
  text-transform: uppercase;
  margin: 0 0 0 0;
`

export const StatusDescription = ContentText.withComponent("h4").extend`
  text-transform: uppercase;
  margin: 0 auto 0 0;
  padding: 0.35rem 1rem;
  background: ${props => props.background};
  foreground: ${props => props.foreground};
`

export const Titles = styled.header`
  display: flex;
  flex-direction: row;
  min-height: 74px;
`

export const StatusUnits = styled.span`text-transform: lowercase;`

export const PreviousButton = styled.button`
  border: none;
  height: 74px;
  width: 74px;
  position: absolute;
  top: 50%;
  left: -37px;
  margin-top: -37px;
  background: transparent;
  transform: rotate(180deg);
`

export const NextButton = PreviousButton.extend`
  left: auto;
  right: -37px;
  transform: rotate(0deg);
`



// WEBPACK FOOTER //
// ./src/Kiosk/GlossaryModal/UI.js